import { j as jsxRuntimeExports } from './jsx-runtime-D2XkDcqR.js';

const GoogleAnalyticsTracking = ({ id, ...config }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
  id ? /* @__PURE__ */ jsxRuntimeExports.jsx("script", { async: true, src: getScriptSrc(id) }) : null,
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    "script",
    {
      dangerouslySetInnerHTML: {
        __html: getScriptInit(id, config)
      }
    }
  )
] });
const getScriptSrc = (id) => "https://www.googletagmanager.com/gtag/js?id=" + id;
const getScriptInit = (id, config) => [
  `dataLayer=[]`,
  `function gtag(){dataLayer.push(arguments)}`,
  `gtag("js",new Date())`,
  `gtag("config",${JSON.stringify(id)},${JSON.stringify(config)})`
].join(";");

export { GoogleAnalyticsTracking };
